<template>
   <div class="csmar-box">
        <img src="../assets/img/csmar.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.csmar-box {
    width: 1200px;
    margin: auto;
    img {
        width:100%;
    }
}

</style>